'use client';
/** Friendly page recovery. Date: 2026-09-10. Version: v1.1. */
import Link from 'next/link';

export default function ErrorPage({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.ReactElement {
  return (
    <main className="center">
      <div className="hero card">
        <h1>We couldn't load this page</h1>
        <p className="muted">
          Try again, return to your daily brief, or open the design preview while the workspace
          reconnects.
        </p>
        <button className="btn primary" onClick={() => reset()}>
          Try again
        </button>
        <div className="actions" style={{ marginTop: '1rem' }}>
          <Link className="btn" href={'/brief' as never}>
            Open daily brief
          </Link>
          <Link className="btn" href={'/preview' as never}>
            Open design preview
          </Link>
        </div>
      </div>
    </main>
  );
}
